import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { SITE_DOMAIN, SUPPORT_EMAIL } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-white/5 mt-10">
    <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col sm:flex-row items-center justify-between gap-8">
      <div className="text-center sm:text-left">
        <p className="font-extrabold text-sm tracking-[0.2em] text-[#4FE3E0]">PULL UP</p>
        <p className="mt-1.5 text-sm text-zinc-400">When you go out, your friends know.</p>
        <p className="mt-1 text-xs text-zinc-600">Get it on iOS & Android · {SITE_DOMAIN}</p>
      </div>

      <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-7 gap-y-3 text-sm">
        <Link data-testid="footer-features-link" to="/features" className="text-zinc-400 hover:text-[#4FE3E0] transition-colors duration-300">
          Features
        </Link>
        <Link data-testid="footer-how-it-works-link" to="/how-it-works" className="text-zinc-400 hover:text-[#4FE3E0] transition-colors duration-300">
          How it works
        </Link>
        <Link data-testid="footer-business-link" to="/business" className="text-zinc-400 hover:text-[#4FE3E0] transition-colors duration-300">
          For Business
        </Link>
        <a
          data-testid="support-email-link"
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-[#4FE3E0] transition-colors duration-300"
        >
          <Mail className="w-4 h-4" />
          {SUPPORT_EMAIL}
        </a>
        <Link
          data-testid="privacy-policy-link"
          to="/privacy"
          className="text-zinc-400 hover:text-[#4FE3E0] transition-colors duration-300"
        >
          Privacy
        </Link>
        <Link
          data-testid="terms-of-service-link"
          to="/terms"
          className="text-zinc-400 hover:text-[#4FE3E0] transition-colors duration-300"
        >
          Terms
        </Link>
      </div>
    </div>
    <div className="border-t border-white/5">
      <p className="max-w-6xl mx-auto px-6 py-5 text-center text-xs text-zinc-600">
        © 2026 Pull Up · Made for the ones who show up
      </p>
    </div>
  </footer>
);
